import React from 'react';
import CustomNavigationItem from '../../customnavigationitems';

export default class MajorCategoriesMobile extends React.Component {
  static propTypes = {
    categories: React.PropTypes.array,
    customNavigationItems: React.PropTypes.array
  };

  renderMobileCategories = () => {
    return this.props.categories.map(cat => <li key={cat.url}>
      <a className="mobilemenu__link" href={cat.url} data-component="mobileMenuLink">
        {cat.name}
        <i className="mobilemenu__link__icon--go" />
      </a>
    </li>, this);
  };

  renderCustomNavigationItems = () => {
    if (!this.props.customNavigationItems) return;

    return this.props.customNavigationItems.map((item, idx) => {
      return <CustomNavigationItem {...item} key={`${item.text}_${item.url}`} />;
    }, this);
  };

  render () {
    return (
      <ul className="mobilemenu__section">
        {this.renderMobileCategories()}
        {this.renderCustomNavigationItems()}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/majorcategories/mobile/index.js